module.exports = __webpack_public_path__ + "img/flow_step_img.5be9493d.png";